import { render, staticRenderFns } from "./BPMSLogs.vue?vue&type=template&id=5d9305f8&"
import script from "./BPMSLogs.js?vue&type=script&lang=js&"
export * from "./BPMSLogs.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports